import { BrandfolderHexColors } from '../enums/colors.js';

const defaultInputLight = {
    backgroundColor: BrandfolderHexColors.White,
    backgroundColorDisabled: '#f9f9f9',
    borderColor: BrandfolderHexColors.GrayBorder,
    borderColorDisabled: BrandfolderHexColors.GrayBorder,
    borderColorError: BrandfolderHexColors.Delete,
    borderColorFocus: BrandfolderHexColors.Text,
    borderColorHover: BrandfolderHexColors.GrayMediumDark,
    outlineColorFocus: BrandfolderHexColors.PurplePopsicle,
    textColor: BrandfolderHexColors.Text,
    textColorDisabled: BrandfolderHexColors.GrayMedium,
    textColorError: BrandfolderHexColors.Text,
    textColorPlaceholder: BrandfolderHexColors.GrayMediumDark
};

export { defaultInputLight };
//# sourceMappingURL=input.js.map
